// Types

/**
 * Interfaces
 */

/**
 * Models
 */

/**
 * Types guards
 */

export function isMediaResponseErrored(json) {
  return json.errors !== undefined;
}
export function isServiceResponseErrored(json) {
  return json.errors !== undefined;
}

/**
 * Request format
 */

export let Cipher = /*#__PURE__*/function (Cipher) {
  Cipher["BLOWFISH"] = "BF_CBC_STRIPE";
  Cipher["NONE"] = "NONE";
  return Cipher;
}({});
export let MediaRequestType = /*#__PURE__*/function (MediaRequestType) {
  MediaRequestType["FULL"] = "FULL";
  MediaRequestType["PREVIEW"] = "PREVIEW";
  return MediaRequestType;
}({});

/**
 * Response format
 */

export let ResponseErrorCode = /*#__PURE__*/function (ResponseErrorCode) {
  ResponseErrorCode[ResponseErrorCode["INVALID_LICENSE_TOKEN"] = 1000] = "INVALID_LICENSE_TOKEN";
  ResponseErrorCode[ResponseErrorCode["EXPIRED_LICENSE_TOKEN"] = 1001] = "EXPIRED_LICENSE_TOKEN";
  ResponseErrorCode[ResponseErrorCode["UNAUTHORIZED_LICENSE_TOKEN"] = 1002] = "UNAUTHORIZED_LICENSE_TOKEN";
  ResponseErrorCode[ResponseErrorCode["API_DEPRECATED"] = 1999] = "API_DEPRECATED";
  return ResponseErrorCode;
}({});
export let MediaErrorCode = /*#__PURE__*/function (MediaErrorCode) {
  MediaErrorCode[MediaErrorCode["INVALID_TRACK_TOKEN"] = 2000] = "INVALID_TRACK_TOKEN";
  MediaErrorCode[MediaErrorCode["EXPIRED_TRACK_TOKEN"] = 2001] = "EXPIRED_TRACK_TOKEN";
  MediaErrorCode[MediaErrorCode["UNAUTHORIZED_TRACK_TOKEN"] = 2002] = "UNAUTHORIZED_TRACK_TOKEN";
  return MediaErrorCode;
}({});
//# sourceMappingURL=types.js.map